module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "region-select"
  }, [_c('div', {
    staticClass: "info-control arr-item",
    on: {
      "click": _vm.showPal
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.labelName))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#aaaaaa"
    }
  }, [_vm._v(_vm._s(_vm.selectIndex >= 0 ? _vm.typeList[_vm.selectIndex].name : ""))])]), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "region-panel"
  }, [(_vm.isShow) ? _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.typeList), function(item, index) {
    return _c('li', {
      staticClass: "list-item card-item",
      on: {
        "click": function($event) {
          return _vm.checked(index)
        }
      }
    }, [_c('i', {
      class: {
        icon: _vm.selectIndex === index
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])])
  }), 0) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4201fb71","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TypeSelect.vue
// module id = 819
// module chunks = 0